export class ReportWrapper {
  reportCode?: string;
  reportType?: string;
  reportingPeriod?: string;
  reportingPeriodType?: string;
  fileType?: string;
  servicerNumber?: string;
  sellerNumber?:string;
}
